import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getShoots } from "../../../Core/Shoots/action";
import { getSingleLocation } from "../../../Core/SingleLocation/action";
import { getSinglePhotographer } from "../../../Core/SinglePhotographer/action";
import { getData, putData } from "../../../Core/Projects/action";
import Card from "./Card";
import styles from "../../../Assets/Styles/Components/Book/Shoots/Shoots.module.css";

class Shoots extends Component {
  constructor(prop) {
    super(prop);
    this.state = {
      isPersonal: true,
      selectedId: null,
      numToShow: 6,
      checked: false,
      isCategory: false,
      allShoots: [],
      filteredShoots: [],
    };
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  componentDidMount() {
    if (!this.props.project.slug) {
      if (window.location.search && window.location.search.substr(1)) {
        this.props.getData(Object.fromEntries(new URLSearchParams(window.location.search.substring(1))).slug, {});
        this.props.getShoots(Object.fromEntries(new URLSearchParams(window.location.search.substring(1))).slug);
      }
    }
    if (this.props.project.slug && this.props.shoots && Object.keys(this.props.shoots.shoots).length !== 0) {
      if (this.props.project.data && this.props.project.data.shoot_type_id) {
        this.setState({ selectedId: this.props.project.data.shoot_type_id });
      }
      if (this.props.project?.data?.shoot_location_slug) {
        this.props.getSingleLocation(this.props.project.data.shoot_location_slug);
      }
    }
    if (this.props.project.slug && this.props.project.data && this.props.project.data.delivery_at_location) {
      this.setState({ checked: this.props.project.data.delivery_at_location });
    }
    if (this.props.project.slug && this.props.shoots && Object.keys(this.props.shoots.shoots).length === 0) {
      // this.props.getData(this.props.project.slug, {});
      this.props.getShoots(this.props.project.slug);
      if (this.props.project.data && this.props.project.data.shoot_type_id) {
        this.setState({ selectedId: this.props.project.data.shoot_type_id });
      }
      // if (this.props.project?.data?.shoot_location_slug) {
      //   this.props.getSingleLocation(this.props.project.data.shoot_location_slug);
      // }
    }
    if (this.props.project?.slug) {
      if (this.props.project?.data?.shoot_location_slug) {
        this.props.getSingleLocation(this.props.project.data.shoot_location_slug);
      }
    }
    window.addEventListener("resize", this.updateDimensions);
    this.updateDimensions();
  }

  componentDidUpdate(preProps) {
    if (
      (this.props.project && this.props.project.data && preProps.project.data.step !== this.props.project.data.step) ||
      (this.props.project && !this.props.project.loading && preProps.project.loading !== this.props.project.loading)) {
      this.props.history.push(`/book/${this.props.project.data.step}?slug=${this.props.project.slug}`);
    }
    if (this.props.project && this.props.project.data && !this.props.project.loading && this.props.project.data.shoot_location_slug && this.props.slocation && !this.props.slocation.loading && Object.keys(this.props.slocation.slocation).length === 0) {
      this.props.getSingleLocation(this.props.project.data.shoot_location_slug);
    }
    if (this.props.project && this.props.project.data && !this.props.project.loading && this.props.project.data.photographer_uid && this.props.project.data.direct_photographer && this.props.sphotographer && !this.props.sphotographer.loading && Object.keys(this.props.sphotographer.sphotographer).length === 0) {
      this.props.getSinglePhotographer(this.props.project.data.photographer_uid);
    }
    if (Object.keys(this.props?.shoots?.shoots)?.length !== 0 && this.state.allShoots.length === 0) {
      this.addShoots();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  addShoots = () => {
    this.setState({ allShoots: this.props.shoots.shoots });
    this.returnShoots(this.props.shoots.shoots, true);
  }

  onSelectChange = (value) => {
    this.setState({ selectedId: value });
  };

  changeTabState = (isPersonal) => () => {
    this.setState({ isPersonal });
    this.returnShoots(this.state.allShoots, isPersonal);
  };

  changeLocation = () => {
    const { slug, data } = this.props.project;
    this.props.getShoots();
    this.setState({ allShoots: [], filteredShoots: [] });
    this.props.putData(slug, { ...data, step: this.props.history.location.pathname.slice(1).split('/')[1], shoot_location_slug: null });
    this.props.getSingleLocation();
    setTimeout(() => {
      this.props.getShoots(this.props.project.slug);
    }, 300);
  }

  changePhotographer = () => {
    const { slug, data } = this.props.project;
    this.props.getShoots();
    this.setState({ allShoots: [], filteredShoots: [] });
    this.props.putData(slug, { ...data, step: this.props.history.location.pathname.slice(1).split('/')[1], photographer_uid: null, direct_photographer: false });
    this.props.getSinglePhotographer();
    setTimeout(() => {
      this.props.getShoots(this.props.project.slug);
    }, 300);
  }

  handleCheckboxChange = () => {
    this.setState({ checked: !this.state.checked });
  }

  returnShoots = (shoots, isPersonal) => {
    // let filteredShoots = [];
    let personalShoots = [];
    let businessShoots = [];
    if (Object.keys(shoots).length !== 0) {
      personalShoots = shoots.filter(
        (item) => item.is_personal
      );
      businessShoots = shoots.filter(
        (item) => item.is_business
      );
      if (Object.keys(personalShoots).length === 0 && Object.keys(businessShoots).length !== 0) {
        this.setState({ isCategory: false, filteredShoots: businessShoots });
      }
      if (Object.keys(personalShoots).length !== 0 && Object.keys(businessShoots).length === 0) {
        this.setState({ isCategory: false, filteredShoots: personalShoots });
      }
      if (Object.keys(personalShoots).length !== 0 && Object.keys(businessShoots).length !== 0 && isPersonal) {
        this.setState({ isCategory: true, filteredShoots: personalShoots });
      }
      if (Object.keys(personalShoots).length !== 0 && Object.keys(businessShoots).length !== 0 && !isPersonal) {
        this.setState({ isCategory: true, filteredShoots: businessShoots });
      }
    }
  }

  updateDimensions() {
    if (window.innerWidth >= 768) {
      this.setState({ numToShow: 30 });
    } else if (Object.keys(this.state.filteredShoots).length > 6) {
      this.setState({ numToShow: 6 });
    } else {
      this.setState({ numToShow: 30 });
    }
  }

  render() {
    const { slocation, sphotographer } = this.props;
    const { isPersonal, selectedId, numToShow, checked, isCategory, allShoots, filteredShoots } = this.state;
    return (
      <div className={`${styles.shoot} container`}>
        <div className="row">
          <div className="col-12">
            {
              Object.keys(slocation?.slocation).length !== 0 &&
              <div className={styles.attentionBox}>
                <div className="row align-items-center">
                  <div className="col-12 col-md-9 align-items-center">
                    <div className="row align-items-center">
                      <div className="col-3 col-md-2 col-lg-1 align-items-center">
                        <img src={`https://kadro.co/${slocation.slocation.avatar.thumb}`} alt="location" />
                      </div>
                      <div className="col-9 col-md-10 col-lg-11 align-items-center">شما &quot;{slocation.slocation.title}&quot; را برای عکاسی انتخاب کرده‌اید.</div>
                    </div>
                  </div>
                  <div className="col-5 col-md-3 ">
                    <div className="row align-items-center">
                      <div className="col-12" onClick={this.changeLocation}><div className={styles.btnChange}>تغییر مکان عکاسی</div></div>
                    </div>
                  </div>
                </div>
              </div>
            }
            {
              Object.keys(sphotographer?.sphotographer).length !== 0 &&
              <div className={styles.attentionBox}>
                <div className="row align-items-center">
                  <div className="col-12 col-md-9 align-items-center">
                    <div className="row align-items-center">
                      <div className="col-3 col-md-2 col-lg-1 align-items-center">
                        <img src={`https://kadro.co/${sphotographer.sphotographer.avatar.thumb}`} alt="location" />
                      </div>
                      <div className="col-9 col-md-10 col-lg-11 align-items-center">شما &quot;{sphotographer.sphotographer.abbrv_name}&quot; را برای عکاسی انتخاب کرده‌اید و در حال مشاهده حوزه‌های کاری ایشان هستید</div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 ">
                    <div className="row align-items-center">
                      <div className="col-12" onClick={this.changePhotographer}><div className={styles.btnChange}>تغییر عکاس</div></div>
                    </div>
                  </div>
                </div>
              </div>
            }
            <div className="custom-box">
              {isCategory &&
                <div className={`${styles.selectionBar} row`}>
                  <div className={`col-6 ${styles.item} ${isPersonal ? styles.selected : ""}`} onClick={this.changeTabState(true)}>شخصی</div>
                  <div className={`col-6 ${styles.item} ${!isPersonal ? styles.selected : ""}`} onClick={this.changeTabState(false)}>تجاری</div>
                </div>}
              <ul className="row">
                {filteredShoots && Object.keys(filteredShoots).length !== 0 &&
                  filteredShoots.slice(0, numToShow).map((shoot) => (
                    <Card
                      selected={selectedId === shoot.id}
                      onSelectChange={this.onSelectChange}
                      checked={checked}
                      {...shoot}
                    />
                  ))}
              </ul>
              {
                numToShow === 6 && <p className={styles.btnMore} onClick={() => { this.setState((prevState) => { return { numToShow: filteredShoots.length < prevState.numToShow ? prevState.numToShow : filteredShoots.length }; }); }}>نمایش بیشتر</p>
              }
              {/* <div className={styles.checkBoxGroup} onClick={this.handleCheckboxChange}>
                <input
                  type="checkbox"
                  onChange={this.handleCheckboxChange}
                  checked={checked}
                />
                <span>میخواهم عکس‌ها را در محل تحویل بگیرم. <span className={styles.moreDescription}>(میتونید از عکاس بخواهید همه عکسها را در این حالت از حافظه دوربین حذف کند).</span></span>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    shoots: state.shoots,
    project: state.project,
    change: state.change.change,
    slocation: state.slocation,
    sphotographer: state.sphotographer
  };
};
export default connect(mapStateToProps, { getShoots, getData, putData, getSingleLocation, getSinglePhotographer })(withRouter(Shoots));
